module.exports = __webpack_public_path__ + "img/level_08_platinum.49ce8238.svg";